<template>
    <LsInfoRow
        class="ls-info-row-last-completed"
        :left-image="require('./assets/complete.svg')"
        label="Last Completed"
        :value="value"
    >
        <v-popover v-if="gps">
            <img :src="require('./assets/location.svg')" />
            <template slot="popover">
                <div class="ls-info-row-last-completed--popover">
                    <span>GPS Verified At:</span><br />
                    <span>{{ gps }}</span>
                </div>
            </template>
        </v-popover>
    </LsInfoRow>
</template>

<script>
import VueTypes from 'vue-types';
import { lsPropTypeHelpers } from 'ls-vue-common';
import _ from 'lodash';
import LsInfoRow from '../LsInfoRow/LsInfoRow.vue';
import { lsHelpers } from '@/helpers';

export default {
    name: 'LsInfoRowLastCompleted',
    components: {
        LsInfoRow,
    },
    props: {
        schedule: VueTypes.shape({
            last_completed_schedule_event: VueTypes.oneOfType([
                VueTypes.shape({
                    status_set_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull).isRequired,
                    geofence: VueTypes.shape({
                        entered_at: VueTypes.custom(lsPropTypeHelpers.stringOrNull).isRequired,
                    }).isRequired.loose,
                }).isRequired.loose,
                VueTypes.oneOfType([null]),
            ]),
        }).isRequired.loose,
    },
    computed: {
        value() {
            if (!_.get(this.schedule, 'last_completed_schedule_event.status_set_at')) {
                return 'N/A';
            }
            return this.time({
                timestamp: this.schedule.last_completed_schedule_event.status_set_at,
            });
        },
        gps() {
            if (!_.get(this.schedule, 'last_completed_schedule_event.geofence.entered_at')) {
                return;
            }
            return this.time({
                timestamp: this.schedule.last_completed_schedule_event.geofence.entered_at,
            });
        },
    },
    methods: {
        time({ timestamp }) {
            if (!timestamp) {
                // handle very old schedule_events with null status_set_at
                return 'Unknown';
            }

            return lsHelpers.parseTimestamp({
                timestamp,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-info-row-last-completed--popover {
    width: 240px;
    color: $secondary-dark;
    line-height: 20px;
    :first-child {
        font-weight: $bold;
    }
}
</style>
